/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from "react"
import { OK } from "utils/constant"

// import { setStorage, removeStorage } from "utils/localstorage"
import { handleCaptchaCode } from "utils/verify"
// import { filter } from "utils/filter"

const fn = () => { }

export default function useSign({
  loading, setloading, $request, successFn, setHint, remember = false, rememberKey = '', rememberObj = {}, noSignup = fn, setIsFocus = (params) => { }, setservice_days = (params) => { }, resetComponent = () => { }
}) {
  return useCallback(async () => {
    if (loading) return
    // if (validate()) {
    setloading(true)
    try {
      const data = await $request()
      if (data.status === OK) {
        // if (remember) {
        //   setStorage(rememberKey, rememberObj)
        // } else if (rememberKey) {
        //   removeStorage(rememberKey)
        // }
        window['nvcReset']()
        resetComponent()
        //重置人机验证

        setIsFocus('blur')
        setservice_days(data.data.service_days)
        successFn()
      } else {
        // localStorage.setItem("showModal",'true')
        const code = data.captcha_code
        if (data.code === 20011) {
          handleCaptchaCode(code)
          // setcaptcha(true)
          if (code === "800" || code === "900") {
            setHint('人机验证不通过')
            setIsFocus('error')
            // setHint({ modal: true, text: "人机验证不通过" })
          } else {
            setHint('请先通过人机验证')
            setIsFocus('error')
          }

        } else {
          // rest之前的
          window['nvcReset']()
          resetComponent()
          if (data.code === 40050) {
            noSignup()
          } else {

            if (data.error === 'cd_key has been used') {
              setHint('该卡密已被使用')
              setIsFocus('error')
            } else if (data.error === 'cd_key has expired') {
              setHint('该卡密已过期')
              setIsFocus('error')
            } else if (data.error === 'validate fail') {
              setHint('请先通过人机验证')
              setIsFocus('error')
            } else if (data.code === 20002) {
              setHint(data.error)
              setIsFocus('error')
            } else {
              setHint('请输入正确的卡密')
              setIsFocus('error')
            }
            // console.log(filter(data.code, data.error));

            // setHint({ modal: true, text: filter(data.code, data.error) })
          }
        }
      }
    } catch (error) {
      // localStorage.setItem("showModal","true")
      window['nvcReset']()
      resetComponent()
      console.log(error)
      setHint('网络错误')
      setIsFocus('error')
      //   setHint({ modal: true, text: "网络错误" })
    }
    setloading(false)
    // }
  }, [loading, setloading, $request, successFn, setHint, remember, rememberKey, rememberObj, noSignup])
}
